module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_3009.c8132470.png";